import { MODULES } from './modules.js';
import { PERMISSIONS } from './permissions.js';
/**
 * The courses the tracker runs. Each one is the same process — webhook / Excel
 * intake, phone check, call + survey follow-up, NSDC kit dispatch — over its own
 * rows of tracker_fdfc (`course` column), behind its own module and permissions.
 */
export const TRACKER_COURSES = ['fdfc', 'bdfc'];
export const TRACKER_COURSE_CONFIG = {
    fdfc: {
        course: 'fdfc',
        label: 'FDFC Tracker',
        slug: 'tracker-fdfc',
        eventSource: 'tracker_fdfc',
        module: MODULES.TRACKER_FDFC,
        permissions: {
            view: PERMISSIONS.TRACKER_FDFC_VIEW,
            import: PERMISSIONS.TRACKER_FDFC_IMPORT,
            dispatch: PERMISSIONS.TRACKER_FDFC_DISPATCH,
            update: PERMISSIONS.TRACKER_FDFC_UPDATE,
        },
    },
    bdfc: {
        course: 'bdfc',
        label: 'BDFC Tracker',
        slug: 'tracker-bdfc',
        eventSource: 'tracker_bdfc',
        module: MODULES.TRACKER_BDFC,
        permissions: {
            view: PERMISSIONS.TRACKER_BDFC_VIEW,
            import: PERMISSIONS.TRACKER_BDFC_IMPORT,
            dispatch: PERMISSIONS.TRACKER_BDFC_DISPATCH,
            update: PERMISSIONS.TRACKER_BDFC_UPDATE,
        },
    },
};
//# sourceMappingURL=tracker-course.js.map